import { IconPack, IconName } from "@fortawesome/fontawesome-svg-core";

// In this file, we export all the Custom Icons that we need from our Fort
// Awesome kit. Fort Awesome does not yet allow exporting custom icons as
// JavaScript files to be imported using React FontAwesome, so for now we have
// to "hack" the custom icons that we need as JavaScript objects from their SVG
// files.

// Generating these objects is very simple — use existing objects either here or
// in the FontAwesome library as examples. The last element in the `icon` array
// is the SVG path pulled from the SVG files in the Fort Awesome Kit when
// downloaded from fortawesome.com.

// Note: you might need to use Adobe Illustrator to make a Compound Shape out of
// the various objects in the original SVG.

const ICON_PACK: IconPack = {
    faConsole: {
        prefix: "fas",
        iconName: "console" as IconName,
        icon: [
            56,
            56,
            [],
            "",
            "M48 0H8C3.6 0 0 3.6 0 8v40c0 4.4 3.6 8 8 8h40c4.4 0 8-3.6 8-8V8c0-4.4-3.6-8-8-8zM25 29.9l-10.6 7.5c-1.8 1.3-4.3.8-5.6-1-1.3-1.8-.8-4.3 1-5.6l6.4-4.5-6.4-4.5c-1.8-1.3-2.2-3.8-1-5.6 1.3-1.8 3.8-2.2 5.6-1L25 22.8c1.2.8 1.8 2.2 1.7 3.5.1 1.4-.5 2.8-1.7 3.6zM44 43H31c-2.2 0-4-1.8-4-4s1.8-4 4-4h13c2.2 0 4 1.8 4 4s-1.8 4-4 4z",
        ],
    },

    faQuery: {
        prefix: "fas",
        iconName: "query" as IconName,
        icon: [
            67.6,
            55,
            [],
            "",
            "M4 8h52c2.2 0 4-1.8 4-4s-1.8-4-4-4H4C1.8 0 0 1.8 0 4s1.8 4 4 4zM4 32h13c2.2 0 4-1.8 4-4s-1.8-4-4-4H4c-2.2 0-4 1.8-4 4s1.8 4 4 4zM66.4 48.7l-8.6-8.6C59.2 37.7 60 35 60 32c0-8.8-7.2-16-16-16s-16 7.2-16 16 7.2 16 16 16c3 0 5.8-.8 8.1-2.2l8.6 8.6c1.6 1.6 4.1 1.6 5.7 0 1.6-1.6 1.6-4.1 0-5.7zM44 41c-5 0-9-4-9-9s4-9 9-9 9 4 9 9-4 9-9 9zM24 48H4c-2.2 0-4 1.8-4 4s1.8 4 4 4h20c2.2 0 4-1.8 4-4s-1.8-4-4-4z",
        ],
    },

    faRow: {
        prefix: "fas",
        iconName: "row" as IconName,
        icon: [
            56,
            56,
            [],
            "",
            "M4 8h48c2.2 0 4-1.8 4-4s-1.8-4-4-4H4C1.8 0 0 1.8 0 4s1.8 4 4 4zM52 32H4c-2.2 0-4 1.8-4 4s1.8 4 4 4h48c2.2 0 4-1.8 4-4s-1.8-4-4-4zM52 16H4c-2.2 0-4 1.8-4 4s1.8 4 4 4h48c2.2 0 4-1.8 4-4s-1.8-4-4-4zM52 48H4c-2.2 0-4 1.8-4 4s1.8 4 4 4h48c2.2 0 4-1.8 4-4s-1.8-4-4-4z",
        ],
    },

    faRowReference: {
        prefix: "fas",
        iconName: "row-reference" as IconName,
        icon: [
            56,
            56,
            [],
            "",
            "M4 8h48c2.2 0 4-1.8 4-4s-1.8-4-4-4H4C1.8 0 0 1.8 0 4s1.8 4 4 4zM4 24h48c2.2 0 4-1.8 4-4s-1.8-4-4-4H4c-2.2 0-4 1.8-4 4s1.8 4 4 4zM56.4 49.6c-.3-.4-.6-.8-1-1.1-.4-.3-.7-.6-1.1-.8.9-.3 1.7-.8 2.3-1.3.7-.5 1.2-1.1 1.7-1.8s.8-1.4 1-2.2c.2-.8.4-1.6.4-2.5 0-1.2-.2-2.2-.6-3.2-.4-1-1-1.8-1.9-2.5s-2-1.3-3.4-1.7c-1.4-.4-3-.6-5-.6H40v27h6.3V49H48c.5 0 .9.1 1.1.2.3.2.5.4.7.7l4.5 7.8c.5.8 1.2 1.2 2.3 1.2h5.7l-5.9-9.3zm-3-7.5c-.2.5-.5 1-.8 1.3-.4.4-.9.7-1.5.9-.6.2-1.3.3-2.2.3h-2.5v-8h2.5c1.6 0 2.8.3 3.6 1 .8.7 1.2 1.6 1.2 2.8-.1.7-.2 1.2-.3 1.7zM0 36c0 2.2 1.8 4 4 4h28v-8H4c-2.2 0-4 1.8-4 4zM0 52c0 2.2 1.8 4 4 4h28v-8H4c-2.2 0-4 1.8-4 4z",
        ],
    },

    faColumn: {
        prefix: "fas",
        iconName: "column" as IconName,
        icon: [
            56,
            56,
            [],
            "",
            "M48 4v48c0 2.2 1.8 4 4 4s4-1.8 4-4V4c0-2.2-1.8-4-4-4s-4 1.8-4 4zM24 52V4c0-2.2-1.8-4-4-4s-4 1.8-4 4v48c0 2.2 1.8 4 4 4s4-1.8 4-4zM40 52V4c0-2.2-1.8-4-4-4s-4 1.8-4 4v48c0 2.2 1.8 4 4 4s4-1.8 4-4zM8 52V4c0-2.2-1.8-4-4-4S0 1.8 0 4v48c0 2.2 1.8 4 4 4s4-1.8 4-4z",
        ],
    },

    faColumnReference: {
        prefix: "fas",
        iconName: "column-reference" as IconName,
        icon: [
            56,
            56,
            [],
            "",
            "M20 0c-2.2 0-4 1.8-4 4v48c0 2.2 1.8 4 4 4s4-1.8 4-4V4c0-2.2-1.8-4-4-4zM4 0C1.8 0 0 1.8 0 4v48c0 2.2 1.8 4 4 4s4-1.8 4-4V4c0-2.2-1.8-4-4-4zM52.4 49.6c-.3-.4-.6-.8-1-1.1-.4-.3-.7-.6-1.1-.8.9-.3 1.7-.8 2.3-1.3.7-.5 1.2-1.1 1.7-1.8s.8-1.4 1-2.2c.2-.8.4-1.6.4-2.5 0-1.2-.2-2.2-.6-3.2-.4-1-1-1.8-1.9-2.5s-2-1.3-3.4-1.7c-1.4-.4-3-.6-5-.6H36v27h6.3V49H44c.5 0 .9.1 1.1.2.3.2.5.4.7.7l4.5 7.8c.5.8 1.2 1.2 2.3 1.2h5.7l-5.9-9.3zm-3-7.5c-.2.5-.5 1-.8 1.3-.4.4-.9.7-1.5.9-.6.2-1.3.3-2.2.3h-2.5v-8h2.5c1.6 0 2.8.3 3.6 1 .8.7 1.2 1.6 1.2 2.8-.1.7-.2 1.2-.3 1.7zM56 4c0-2.2-1.8-4-4-4s-4 1.8-4 4v20h8V4zM36 0c-2.2 0-4 1.8-4 4v20h8V4c0-2.2-1.8-4-4-4z",
        ],
    },

    faNodes: {
        prefix: "fas",
        iconName: "nodes" as IconName,
        icon: [
            56,
            56,
            [],
            "",
            `M28,0c4.5,0,8.2,3.7,8.2,8.2s-3.7,8.2-8.2,8.2s-8.2-3.7-8.2-8.2S23.5,0,28,0z M28,39.6c4.5,0,8.2,3.7,8.2,8.2S32.5,56,28,56
            s-8.2-3.7-8.2-8.2S23.5,39.6,28,39.6z M8.2,9.9c4.5,0,8.2,3.7,8.2,8.2s-3.7,8.2-8.2,8.2S0,22.6,0,18.1S3.7,9.9,8.2,9.9z M47.8,9.9
            c4.5,0,8.2,3.7,8.2,8.2s-3.7,8.2-8.2,8.2s-8.2-3.7-8.2-8.2S43.3,9.9,47.8,9.9z M8.2,29.7c4.5,0,8.2,3.7,8.2,8.2s-3.7,8.2-8.2,8.2
            S0,42.4,0,37.9S3.7,29.7,8.2,29.7z M47.8,29.7c4.5,0,8.2,3.7,8.2,8.2s-3.7,8.2-8.2,8.2s-8.2-3.7-8.2-8.2S43.3,29.7,47.8,29.7z
            M28,19.8c4.5,0,8.2,3.7,8.2,8.2s-3.7,8.2-8.2,8.2s-8.2-3.7-8.2-8.2S23.5,19.8,28,19.8z`,
        ],
    },

    faPipelines: {
        prefix: "fas",
        iconName: "pipelines" as IconName,
        icon: [
            56,
            56,
            [],
            "",
            "M38.3 8H52c2.2 0 4-1.8 4-4s-1.8-4-4-4H38.3c-2.2 0-4 1.8-4 4s1.8 4 4 4zM52 16H21c-2.2 0-4 1.8-4 4s1.8 4 4 4h31c2.2 0 4-1.8 4-4s-1.8-4-4-4zM52 32H6.3c-2.2 0-4 1.8-4 4s1.8 4 4 4H52c2.2 0 4-1.8 4-4s-1.8-4-4-4zM52 48H34.5c-2.2 0-4 1.8-4 4s1.8 4 4 4H52c2.2 0 4-1.8 4-4s-1.8-4-4-4zM20.7 48h-1.3c-2.2 0-4 1.8-4 4s1.8 4 4 4h1.3c2.2 0 4-1.8 4-4s-1.8-4-4-4zM22.5 8h1.3c2.2 0 4-1.8 4-4s-1.8-4-4-4h-1.3c-2.2 0-4 1.8-4 4s1.8 4 4 4zM5.3 24c2.2 0 4-1.8 4-4s-1.8-4-4-4H4c-2.2 0-4 1.8-4 4s1.8 4 4 4h1.3z",
        ],
    },

    faDatabase: {
        prefix: "fas",
        iconName: "database" as IconName,
        icon: [
            56,
            56,
            [],
            "",
            `M28,0.5c13,0,23.6,3.5,23.6,7.9v3.9c0,4.3-10.5,7.9-23.6,7.9S4.4,16.6,4.4,12.3V8.4C4.4,4.1,15,0.5,28,0.5z M28,35.9
            c9.2,0,18.5-1.6,23.6-5.2v5.2c0,4.3-10.5,7.9-23.6,7.9S4.4,40.2,4.4,35.9v-5.2C9.5,34.2,18.8,35.9,28,35.9z M28,47.6
            c9.2,0,18.5-1.6,23.6-5.2v5.2c0,4.3-10.5,7.9-23.6,7.9S4.4,51.9,4.4,47.6v-5.2C9.5,46,18.8,47.6,28,47.6z M28,24.1
            c9.2,0,18.5-1.6,23.6-5.2v5.2c0,4.3-10.5,7.9-23.6,7.9S4.4,28.4,4.4,24.1v-5.2C9.5,22.4,18.8,24.1,28,24.1z
            `,
        ],
    },

    faJson: {
        prefix: "far",
        iconName: "json" as IconName,
        icon: [
            56,
            56,
            [],
            "",
            `M8.6,0.7C7.1,1.2,5.9,2,5,2.9c-1,0.9-1.7,2-2.1,3.3s-0.7,2.7-0.7,4.3c0,1,0.1,1.9,0.2,2.8c0.1,0.9,0.2,1.8,0.4,2.8
            C3,17,3.1,17.9,3.2,18.9c0.1,0.9,0.2,1.8,0.2,2.7c0,1.2-0.3,2.2-0.8,2.9c-0.5,0.8-1.4,1.1-2.6,1.1v4.7c1.2,0,2.1,0.4,2.6,1.1
            c0.5,0.8,0.8,1.7,0.8,2.9c0,0.9-0.1,1.8-0.2,2.8c-0.1,1-0.3,1.9-0.4,2.9c-0.1,0.9-0.3,1.8-0.4,2.8c-0.1,0.9-0.2,1.9-0.2,2.8
            c0,1.6,0.2,3,0.7,4.3C3.3,51.1,4,52.2,5,53.1s2.2,1.6,3.6,2.1c1.5,0.5,3.2,0.7,5.2,0.7h1.6v-3.6c0-0.3-0.1-0.5-0.2-0.7
            c-0.1-0.2-0.3-0.4-0.4-0.5l-0.6-0.3c-0.2-0.1-0.4-0.1-0.5-0.1h-0.1c-1.3,0-2.3-0.4-3-1.3c-0.7-0.8-1-2-1-3.4c0-1.1,0-2.1,0.1-3.1
            s0.2-2,0.3-2.9s0.3-1.9,0.4-2.8c0.1-0.9,0.1-1.8,0.1-2.8c0-0.7-0.1-1.4-0.3-2.1C10,31.6,9.7,31,9.3,30.4s-0.9-1.1-1.5-1.5
            s-1.2-0.8-2-1c0.7-0.2,1.4-0.5,2-1c0.6-0.4,1.1-0.9,1.5-1.5s0.7-1.2,0.9-1.9c0.2-0.7,0.3-1.4,0.3-2.2c0-0.9,0-1.8-0.1-2.7
            S10,16.9,9.9,16s-0.2-1.9-0.3-2.9s-0.1-2-0.1-3.1c0-1.5,0.3-2.6,1-3.4s1.7-1.3,3-1.3h0.1c0.1,0,0.3,0,0.5-0.1l0.6-0.3
            c0.2-0.1,0.3-0.3,0.4-0.5c0.1-0.2,0.2-0.4,0.2-0.7V0h-1.6C11.8,0,10,0.2,8.6,0.7z M53.4,24.5c-0.5-0.8-0.8-1.7-0.8-2.9
            c0-0.9,0.1-1.8,0.2-2.7c0.1-0.9,0.3-1.8,0.4-2.8c0.2-0.9,0.3-1.9,0.4-2.8c0.1-0.9,0.2-1.9,0.2-2.8c0-1.6-0.2-3-0.7-4.3
            C52.7,4.9,52,3.8,51,2.9c-0.9-0.9-2.1-1.6-3.6-2.1C46,0.2,44.2,0,42.3,0h-1.6v3.6c0,0.3,0.1,0.5,0.2,0.7c0.1,0.2,0.3,0.4,0.4,0.5
            l0.6,0.3c0.2,0.1,0.4,0.1,0.5,0.1h0.1c1.3,0,2.3,0.4,3,1.3c0.7,0.8,1,2,1,3.4c0,1.1,0,2.1-0.1,3.1s-0.2,2-0.4,2.9l-0.3,2.7
            c-0.1,0.9-0.1,1.8-0.1,2.7c0,0.8,0.1,1.5,0.3,2.2s0.5,1.3,0.9,1.9s0.9,1.1,1.5,1.5s1.3,0.7,2,1c-0.8,0.2-1.4,0.5-2,1
            c-0.6,0.4-1.1,0.9-1.5,1.5s-0.7,1.2-0.9,1.9s-0.3,1.4-0.3,2.1c0,0.9,0,1.8,0.1,2.8c0.1,0.9,0.2,1.8,0.3,2.8c0.1,0.9,0.3,1.9,0.4,2.9
            c0.1,1,0.1,2,0.1,3.1c0,1.4-0.3,2.6-1,3.4c-0.7,0.8-1.7,1.3-3,1.3h-0.1c-0.2,0-0.3,0-0.5,0.1l-0.6,0.3c-0.2,0.1-0.3,0.3-0.4,0.5
            c-0.1,0.2-0.2,0.4-0.2,0.7V56h1.6c2,0,3.7-0.2,5.1-0.7c1.5-0.5,2.7-1.2,3.6-2.1c1-0.9,1.7-2,2.1-3.3c0.5-1.3,0.7-2.7,0.7-4.3
            c0-1-0.1-1.9-0.2-2.8c-0.1-0.9-0.3-1.9-0.4-2.8c-0.1-0.9-0.3-1.9-0.4-2.8c-0.1-0.9-0.2-1.8-0.2-2.8c0-1.2,0.3-2.2,0.8-2.9
            c0.5-0.8,1.4-1.1,2.6-1.1v-4.7C54.8,25.7,53.9,25.3,53.4,24.5L53.4,24.5z M28,16c2.8,0,5,2.2,5,5s-2.2,5-5,5s-5-2.2-5-5
            S25.2,16,28,16z M33,42.2c0-2.8-2.2-5-5-5s-5,2.2-5,5v0.2c-0.1,0.4-0.1,0.8-0.1,1.1c0,1,0.1,2,0.4,3.1s0.7,2.2,1.3,3.3
            c0.6,1.1,1.3,2.2,2.2,3.2c0.9,1.1,1.9,2,3,2.9l1.4-1.3l0.5-0.5c0.1-0.2,0.1-0.4,0.1-0.7c0-0.2-0.1-0.4-0.2-0.6
            c-0.1-0.2-0.3-0.4-0.5-0.6c-0.2-0.2-0.5-0.5-0.8-0.9c-0.3-0.3-0.6-0.7-1-1.2c-0.3-0.4-0.6-0.9-0.9-1.4s-0.5-1.1-0.6-1.6
            c0.4,0,0.7-0.1,1-0.1C31.3,46.6,33,44.6,33,42.2z`,
        ],
    },

    faAggregate: {
        prefix: "fas",
        iconName: "aggregate" as IconName,
        icon: [
            55.9,
            59,
            [],
            "",
            `M7.8,41.9c0-1.7,1.4-3.1,3.1-3.1h18.6c1.7,0,3.1,1.4,3.1,3.1v6.2c0,1.7-1.4,3.1-3.1,3.1H10.9c-1.7,0-3.1-1.4-3.1-3.1V41.9z   M7.8,26.4c0-1.7,1.4-3.1,3.1-3.1h18.6c1.7,0,3.1,1.4,3.1,3.1v6.2c0,1.7-1.4,3.1-3.1,3.1H10.9c-1.7,0-3.1-1.4-3.1-3.1V26.4z   M23.3,10.9c0-1.7,1.4-3.1,3.1-3.1H45c1.7,0,3.1,1.4,3.1,3.1v6.2c0,1.7-1.4,3.1-3.1,3.1H26.4c-1.7,0-3.1-1.4-3.1-3.1V10.9z M0,20.2  c0-2.6,2.1-4.7,4.7-4.7H14v3.1H4.7c-0.9,0-1.6,0.7-1.6,1.6v34.2c0,0.9,0.7,1.6,1.6,1.6H14V59H4.7C2.1,59,0,56.9,0,54.3V20.2z   M55.9,4.7c0-2.6-2.1-4.7-4.7-4.7h-9.3v3.1h9.3c0.9,0,1.6,0.7,1.6,1.6v27.9c0,0.9-0.7,1.6-1.6,1.6h-9.3v3.1h9.3  c2.6,0,4.7-2.1,4.7-4.7V4.7z`,
        ],
    },

    faUdf: {
        prefix: "fas",
        iconName: "udf" as IconName,
        icon: [
            58.1,
            55,
            [],
            "",
            `M37.3,18.6c-0.3-0.6-0.6-1-0.9-1.4c-0.3-0.3-0.6-0.5-1-0.5c-0.5,0-1,0.1-1.4,0.3c-0.4,0.2-1,0.1-1.2-0.3l-0.3-0.6  c-0.1-0.2-0.1-0.5,0.1-0.7c0.2-0.2,0.5-0.5,0.9-0.8c0.6-0.5,1.4-0.9,2.4-1.2c1-0.4,2-0.6,3.2-0.6c1.2,0,2.2,0.2,3,0.7  c0.8,0.4,1.3,1.1,1.5,1.9l1.7,6.4c0.2,0.6,1,0.7,1.3,0.2l5.6-8.7c0.1-0.2,0.4-0.3,0.6-0.3h4.6c0.6,0,0.9,0.7,0.6,1.2L47.9,27  c-0.2,0.2-0.2,0.5-0.1,0.8l3.9,8c0.2,0.6,0.6,1.2,1,1.8c0.4,0.5,0.9,0.8,1.3,0.8c0.6,0,1.2-0.2,1.9-0.7c0.4-0.2,0.9-0.2,1.1,0.2  l0.4,0.7c0.1,0.2,0.1,0.5,0,0.7c-0.2,0.3-0.6,0.6-1,1.1c-0.7,0.6-1.5,1.1-2.6,1.6c-1.1,0.5-2.3,0.7-3.6,0.7c-1.1,0-2-0.2-2.7-0.7  c-0.7-0.5-1.1-1.2-1.4-2l-2-7c-0.2-0.6-1-0.7-1.3-0.2l-5.8,9.1c-0.1,0.2-0.4,0.3-0.6,0.3h-4.9c-0.6,0-0.9-0.7-0.6-1.2l10.4-13.1  c0.2-0.2,0.2-0.5,0.1-0.8L37.3,18.6z M13.1,10.9c0.3-2.1,1-3.9,2-5.6c1-1.7,2.3-3,3.9-3.9S22.4,0,24.4,0c1.5,0,2.7,0.1,3.7,0.4  c0.4,0.1,0.6,0.5,0.4,0.9l-0.9,2.5c-0.2,0.5-0.7,0.6-1.2,0.4c-0.8-0.4-1.7-0.6-2.6-0.6c-1.3,0-2.2,0.5-2.8,1.4c-0.6,1-1,2.4-1.2,4.4  l-0.4,3c-0.1,0.4,0.3,0.8,0.7,0.8h6.9c0.4,0,0.8,0.4,0.7,0.8l-0.4,2.4c-0.1,0.3-0.4,0.6-0.7,0.6h-7.1c-0.4,0-0.7,0.3-0.7,0.6  L15.9,40c-0.6,4.2-1.8,7.8-3.8,10.6C10.2,53.5,7.6,55,4.4,55c-0.8,0-1.6,0-2.5-0.1c-0.5-0.1-1-0.1-1.4-0.2c-0.4-0.1-0.6-0.5-0.5-0.9  L0.9,51c0.1-0.4,0.6-0.6,1-0.5c0.3,0.1,0.7,0.2,1.2,0.4c0.8,0.3,1.5,0.4,2,0.4c0.9,0,1.7-0.5,2.2-1.4c0.6-0.9,0.9-2.3,1.2-4.1  l3.5-27.9c0.1-0.4-0.3-0.8-0.7-0.8H6.7c-0.5,0-0.8-0.4-0.7-0.9l0.2-1c0.1-0.3,0.3-0.5,0.5-0.6l5.5-1.3c0.3-0.1,0.5-0.3,0.5-0.6  L13.1,10.9z`,
        ],
    },

    faStoredProcedure: {
        prefix: "fas",
        iconName: "stored-procedure" as IconName,
        icon: [
            55.8,
            57,
            [],
            "",
            `M3.5,6.7H19c1.9,0,3.5-1.5,3.5-3.4C22.5,1.5,21,0,19,0H3.5C1.6,0,0,1.5,0,3.4C0,5.2,1.6,6.7,3.5,6.7z M15.8,26.9H3.5  c-1.9,0-3.5,1.5-3.5,3.4c0,1.8,1.6,3.4,3.5,3.4h12.3c1.9,0,3.5-1.5,3.5-3.4C19.2,28.4,17.7,26.9,15.8,26.9z M9.2,13.5H3.5  C1.6,13.5,0,15,0,16.8c0,1.8,1.6,3.4,3.5,3.4h5.7c1.9,0,3.5-1.5,3.5-3.4C12.7,15,11.1,13.5,9.2,13.5z M38.7,13.5H23.2  c-1.9,0-3.5,1.5-3.5,3.4c0,1.8,1.6,3.4,3.5,3.4h15.6c1.9,0,3.5-1.5,3.5-3.4C42.2,15,40.6,13.5,38.7,13.5z M12.5,40.4h-9  c-1.9,0-3.5,1.5-3.5,3.4c0,1.8,1.6,3.4,3.5,3.4h9c1.9,0,3.5-1.5,3.5-3.4C16,41.9,14.4,40.4,12.5,40.4z M37.1,53.9  c1.5,0.3,3.1,0.3,4.7,0l1.2,2.1c0.1,0.4,0.4,0.7,0.9,0.9c0.4,0.1,0.9,0.1,1.3,0c1.8-0.6,3.2-1.6,4.7-2.8c0.3-0.3,0.6-0.6,0.6-1  c0-0.4,0-0.9-0.1-1.3l-1.2-2.1c0.9-1.2,1.8-2.5,2.3-4h2.3c0.4,0,0.9-0.1,1.2-0.4c0.3-0.3,0.6-0.6,0.6-1.2c0.3-1.8,0.3-3.6,0-5.5  c0-0.3-0.3-0.7-0.6-1c-0.3-0.3-0.7-0.4-1.2-0.4h-2.3c-0.6-1.5-1.5-2.8-2.3-4.2l1.2-2.1c0.1-0.3,0.1-0.7,0.1-1.2  c0-0.4-0.3-0.9-0.6-1.2c-1.5-1.2-2.9-2.1-4.7-2.7c-0.4-0.1-0.9-0.1-1.3,0c-0.4,0.1-0.7,0.4-0.9,0.7l-1.2,2.2  c-1.6-0.3-3.2-0.3-4.7-0.1l-1.2-2.1c-0.3-0.3-0.6-0.6-1-0.7c-0.4-0.1-0.9-0.1-1.2,0C32,26,30.3,26.9,29,28.1  c-0.4,0.3-0.7,0.7-0.7,1.2c0,0.4,0,0.9,0.3,1.2l1.2,2.1c-1,1.3-1.8,2.7-2.3,4.2h-2.3c-0.6,0-1,0.1-1.3,0.4c-0.3,0.3-0.6,0.7-0.6,1  c-0.3,1.9-0.3,3.7,0.1,5.5c0,0.6,0.1,0.9,0.4,1.2c0.3,0.3,0.7,0.4,1.3,0.4h2.3c0.6,1.5,1.3,2.8,2.3,4l-1.2,2.1  c-0.3,0.4-0.3,0.9-0.3,1.3c0,0.4,0.3,0.7,0.7,1c1.3,1.2,2.9,2.2,4.7,2.8c0.3,0.1,0.7,0.1,1.2,0c0.4-0.1,0.7-0.4,1-0.9L37.1,53.9z   M35.6,45.1c-1.5-1.8-1.9-3.6-1.3-5.4c0.6-1.8,1.8-3.1,3.5-3.7c1.8-0.6,3.7-0.1,5.4,1.2c1.3,1.9,1.8,3.7,1.2,5.5  c-0.6,1.8-1.8,3-3.5,3.6C39.1,46.9,37.4,46.6,35.6,45.1z`,
        ],
    },

    faHdfs: {
        prefix: "fas",
        iconName: "hdfs" as IconName,
        icon: [
            54,
            41.3,
            [],
            "",
            "M53.6,11.4C53.4,10.1,53,8,52.6,7.1c-3.2-0.2-5.2,3.9-5.2,3.3c0.2,2.4,0.2,4.8-1.2,6.9c0.1-1.5,0.2-3,0.4-4.8  c-0.6,0.2-0.8,0.4-0.9,0.5c-0.6,1.1-1.1,2.3-1.7,3.3h-0.2c0.1-1.2,0.4-2.4,0.5-3.6c-0.1,0-0.1-0.1-0.2-0.1c-0.6,0.8-1.2,1.5-1.9,2.6  c0.5-2.5,1.4-4,3.9-4c-0.7,0,0.5-1.8-0.1-2.9c-0.6-0.7-2.8-3.3-4.4-3.3c0.1-1.4-3.9-4.4-6.5-5C32-0.6,24.5,2.3,24.1,4.6h2.9  c-0.8,0-1.7,0.5-2.5,0.7c-1.2,0.2-2.4,0.6-3.1,1.3c-2.6,2.7-4.6,5.4-7,8.3c-1.4,1.8-1.4,3-0.2,4.8c0.2,0.4,0.7,0.6,0.9,1  c1.1-1.2,1.7-1.4,2.6-2.6c-0.7,1.9-0.7,3.5-1.7,5.2c-0.6,1.2-0.9,1.8,0.1,2.6c1.3,1.1,2.5,0.7,3.9,0c1.7-0.8,2.8-1.7,4.6-2.3  c0.9-0.4,1.5-0.7,1.5-1.5c0-2,0.2-3.5,0.2-5.5c0-1.9,0-3.7,0-5.6c0.2,0,0.5,0,0.6,0c0.4,3.5,0.8,6.8,1.1,10.2  c0.1,1.1-0.4,2.1-0.6,3.2c-0.1,0.4-0.6,0.8-0.9,1c-2.1,1-4.4,1.8-6.5,2.7c-2.4,1.1-5.5,0-6.6-2.3c-0.1-0.2-0.2-0.6-0.1-0.8  c0.8-1.9-0.1-3.2-1.2-4.5C11,19,10.8,17.4,12,15.7c1.4-2,2.8-4.2,4.2-6.2c-5,0.6-9,3.5-11,7.5c-0.8-0.8-3.5-2.6-3.4-3.1  c-2.1,1.4-2.2,2-1.2,3.8c0-0.2,2.2,1.7,3.3,2.6c-0.2,1.2-0.4,2.5-0.2,3.9C4,27.5,5.3,30.5,7,33.1c0.6,1.1,0.7,2,0.5,3.1  c-0.8,3.6-0.8,3.6,2.8,4.4c0.5,0.1,0.9,0.1,1.4,0.2c0.9,0.1,1.4-0.2,1.5-1.3c0.1-0.8,0.5-1.5,0.7-2.4c0.2-1,0.6-1.9,0.7-2.9  c0.1-1,0-1.9,0-2.9c0.1-0.1,0.4-0.2,0.5-0.4c-0.2,2.5,1.7,2.4,3.1,2.4c1.8,0,3.9,0.5,5.1-2v3c-2.4,0.6-2.6,1-3.2,1.8  c-0.4,0.4-0.1,1.5,0.2,2.3c0.4,0.8,0.8,1.5,1.4,2.1c0.9,1,1.9,1,2.7,0c0.6-0.6,1.2-1.3,1.9-1.8c3.9-2.5,5.4-6.4,6.5-10.6  c0.2-0.8,0-1.3-0.7-1.8c-0.7-0.4-1.3-1.1-1.9-1.7c0.1-0.1,0.2-0.5,0.4-0.4c7.4,6,8.3,4.8,8.4,4.8c-2.2-0.1-1.8-1.5-1.7-2.9  c0.1-1.1,0.4-2,0.5-2.9c2.1,0.6,4.4,1.3,6.5,1.7c4.2,0.7,7.3-1.2,8.7-5.4C54.3,16.9,54.1,14.2,53.6,11.4z M36.9,12.6  c-0.9,0.6-2,0.5-3.2,0.8c0.9-2.1,2.1-3.1,4.7-3.5C38.1,11.3,37.7,12,36.9,12.6z M46,8.4c0,0,0-0.1,0-0.1C46.1,8.5,46.1,8.5,46,8.4z   M45.8,8.2c0,0,0,0,0.1,0.1C45.9,8.3,45.9,8.3,45.8,8.2z M5.8,33.9c0.1,0.4,0.2,1,0,1.2c-0.2,0.4-0.8,0.4-1.2,0.4  c-0.4-0.1-0.8-0.4-1.2-0.6c-2.7-2.1-3.8-3.6-0.2-6C4.2,30.7,5,32.2,5.8,33.9z M39.7,25l3.4,1.1c0,0-1.4,1.3-2.4,1.4  s-1.4-0.1-1.4-0.5C39.4,26.8,39.7,25.1,39.7,25z M35.8,37c0.1,0.8-0.1,1.4-1.2,1.4c-1.2,0-2.2,0-3.7,0c0.8-1.4,1.5-2.4,2.1-3.6  s0.9-2.4,1.7-4c0.4,1.2,0.6,1.9,0.7,2.7C35.6,34.7,35.6,35.8,35.8,37z",
        ],
    },

    faKafka: {
        prefix: "fas",
        iconName: "kafka" as IconName,
        icon: [
            36.2,
            59.1,
            [],
            "",
            "M28.6,32.8c-2.3,0-4.3,1-5.7,2.6l-3.6-2.6c0.4-1.1,0.6-2.2,0.6-3.4c0-1.2-0.2-2.3-0.6-3.3l3.6-2.5c1.4,1.6,3.5,2.6,5.7,2.6  c4.2,0,7.7-3.5,7.7-7.7s-3.4-7.7-7.7-7.7s-7.7,3.5-7.7,7.7c0,0.8,0.1,1.5,0.3,2.2l-3.6,2.5c-1.5-1.9-3.7-3.2-6.1-3.6v-4.4  c3.5-0.7,6.1-3.8,6.1-7.5c0-4.3-3.4-7.7-7.7-7.7C5.7,0,2.2,3.5,2.2,7.7c0,3.7,2.5,6.7,6,7.5v4.4C3.5,20.5,0,24.5,0,29.4  c0,4.9,3.6,9,8.3,9.8v4.7c-3.4,0.8-6,3.8-6,7.5c0,4.3,3.4,7.7,7.7,7.7c4.2,0,7.7-3.5,7.7-7.7c0-3.7-2.6-6.8-6-7.5v-4.7  c2.4-0.4,4.5-1.7,6-3.5l3.6,2.6c-0.2,0.7-0.3,1.4-0.3,2.2c0,4.3,3.4,7.7,7.7,7.7s7.7-3.5,7.7-7.7S32.8,32.8,28.6,32.8z M28.6,14.7  c2.1,0,3.7,1.7,3.7,3.7c0,2.1-1.7,3.7-3.7,3.7c-2.1,0-3.7-1.7-3.7-3.7C24.8,16.4,26.5,14.7,28.6,14.7z M6.2,7.7C6.2,5.6,7.9,4,9.9,4  s3.7,1.7,3.7,3.7c0,2.1-1.7,3.7-3.7,3.7S6.2,9.8,6.2,7.7z M13.6,51.4c0,2.1-1.7,3.7-3.7,3.7s-3.7-1.7-3.7-3.7c0-2.1,1.7-3.7,3.7-3.7  S13.6,49.4,13.6,51.4z M9.9,34.6c-2.9,0-5.2-2.3-5.2-5.2s2.3-5.2,5.2-5.2c2.9,0,5.2,2.3,5.2,5.2S12.8,34.6,9.9,34.6z M28.6,44.2  c-2.1,0-3.7-1.7-3.7-3.7c0-2.1,1.7-3.7,3.7-3.7c2.1,0,3.7,1.7,3.7,3.7C32.3,42.5,30.6,44.2,28.6,44.2z",
        ],
    },

    faS3: {
        prefix: "fas",
        iconName: "s3" as IconName,
        icon: [
            69.7,
            53,
            [],
            "",
            "M38.9,18.3l-8.1-2.7V3.7l8.2,2.4L38.9,18.3z M41.1,6.1l8.2-2.4l0,11.9l-8.1,2.7V6.1z M47.5,2.4L40,0l-7.5,2.4l7.5,2  L47.5,2.4z M59.5,18.3l-8.1-2.7V3.7l8.2,2.4L59.5,18.3z M61.6,6.1l8.2-2.4l0,11.9l-8.1,2.7V6.1z M68.1,2.4L60.5,0L53,2.4l7.5,2  L68.1,2.4z M8.2,23.5L0,21v11.9l8.1,2.7L8.2,23.5z M10.3,23.5l8.2-2.4l0,11.9l-8.1,2.7V23.5z M16.8,19.7l-7.6-2.4l-7.5,2.4l7.5,2  L16.8,19.7z M28.7,35.6l-8.1-2.7V21l8.2,2.4L28.7,35.6z M30.8,23.5l8.2-2.4l0,11.9l-8.1,2.7V23.5z M37.3,19.7l-7.6-2.4l-7.5,2.4  l7.5,2L37.3,19.7z M18.4,53l-8.1-2.7V38.4l8.2,2.4L18.4,53z M20.5,40.8l8.2-2.4l0,11.9L20.5,53V40.8z M27,37.1l-7.6-2.4l-7.5,2.4  l7.5,2L27,37.1z",
        ],
    },

    faFilesystem: {
        prefix: "fas",
        iconName: "filesystem" as IconName,
        icon: [
            48,
            56,
            [],
            "",
            "M48,5.1v30.5H0V5.1C0,2.3,2.3,0,5.1,0h37.9C45.7,0,48,2.3,48,5.1z M0,38.2h48v12.7c0,2.8-2.3,5.1-5.1,5.1H5.1  C2.3,56,0,53.7,0,50.9V38.2z M17.3,47.9c0,1.5,1.2,2.8,2.8,2.8c1.5,0,2.8-1.2,2.8-2.8s-1.2-2.8-2.8-2.8  C18.6,45.1,17.3,46.4,17.3,47.9z M7.2,47.9c0,1.5,1.2,2.8,2.8,2.8c1.5,0,2.8-1.2,2.8-2.8s-1.2-2.8-2.8-2.8  C8.5,45.1,7.2,46.4,7.2,47.9z",
        ],
    },

    faAzure: {
        prefix: "fas",
        iconName: "azure" as IconName,
        icon: [
            56,
            56,
            [],
            "",
            "M0,0h26v26H0V0z M0,56h26V30H0V56z M30,30v26h26V30H30z M55.9,26.1H29.9V0h26.1V26.1z M50,6H36v14h14V6z",
        ],
    },

    faInformationSchema: {
        prefix: "fas",
        iconName: "information-schema" as IconName,
        icon: [
            16,
            16,
            [],
            "",
            "M4.976 3.764c-.334-.433-.72-.709-1.181-.763-.055.001-.11.006-.165.014C1.956 3.28 1.043 5.64 1 8c.043 2.36.956 4.72 2.63 4.986.055.008.11.012.165.014.462-.055.847-.33 1.181-.764C4.1 11.268 3.675 9.558 3.646 8c.029-1.557.453-3.268 1.33-4.236zm7.353-.749A1.235 1.235 0 0 0 12.164 3h-2.6c.311.031.598.132.859.292.204.125.39.285.56.472.876.968 1.301 2.679 1.329 4.236-.028 1.557-.453 3.268-1.33 4.236a2.59 2.59 0 0 1-.56.472c-.26.16-.547.26-.859.291h2.601c.055-.001.11-.005.165-.014 1.674-.265 2.587-2.625 2.63-4.985-.043-2.36-.956-4.72-2.63-4.985z  M8.78 11.551c-.12.256-.242.484-.37.689a.093.093 0 0 0 .01.109c.28.33.6.555.967.63.058.012.117.019.176.02.312-.03.599-.13.86-.29.203-.126.39-.285.559-.473-.522-.676-.92-1.736-1.295-2.943-.013-.044-.076-.044-.089 0-.24.8-.5 1.582-.818 2.258zM4.976 3.764c.522.676.92 1.737 1.295 2.943.013.044.075.044.088 0 .241-.799.502-1.581.819-2.258.12-.255.242-.484.369-.688a.093.093 0 0 0-.008-.11c-.282-.33-.6-.554-.969-.63A1.046 1.046 0 0 0 6.355 3a10498.558 10498.558 0 0 1-2.56 0c.461.054.847.33 1.181.763zm5.446-.472c-.26-.16-.548-.26-.86-.291a1.024 1.024 0 0 0-.175.02c-1.411.29-2.094 2.77-2.733 4.98-.497 1.72-.976 3.326-1.678 4.235-.334.434-.72.709-1.182.763l.033.001a10498.558 10498.558 0 0 1 2.568 0c.059-.003.117-.009.175-.02 1.412-.29 2.095-2.771 2.734-4.98.497-1.721.975-3.327 1.677-4.236a2.586 2.586 0 0 0-.559-.472z",
        ],
    },

    faIndex: {
        prefix: "fas",
        iconName: "index" as IconName,
        icon: [
            62.1,
            58.5,
            [],
            "",
            "M61.3,53.8l-5.9-5.9c1-1.6,1.5-3.5,1.5-5.6c0-6.1-4.9-11-11-11s-11,4.9-11,11s4.9,11,11,11c2.1,0,4-0.6,5.6-1.6l5.9,5.9  c1.1,1.1,2.8,1.1,3.9,0C62.4,56.6,62.4,54.8,61.3,53.8z M45.8,48.5c-3.4,0-6.2-2.8-6.2-6.2c0-3.4,2.8-6.2,6.2-6.2s6.2,2.8,6.2,6.2  C52,45.7,49.3,48.5,45.8,48.5z M0,4c0-2.2,1.8-4,4-4h48c2.2,0,4,1.8,4,4s-1.8,4-4,4H4C1.8,8,0,6.2,0,4z M0,20c0-2.2,1.8-4,4-4h48  c2.2,0,4,1.8,4,4s-1.8,4-4,4H4C1.8,24,0,22.2,0,20z M0,36c0-2.2,1.8-4,4-4h24.5c-1.3,2.4-2.2,5.1-2.4,8H4C1.8,40,0,38.2,0,36z   M32,55.6V56H4c-2.2,0-4-1.8-4-4s1.8-4,4-4h23.1C28.2,50.9,29.8,53.5,32,55.6z",
        ],
    },

    veoperatorsnestedloopjoin: {
        prefix: "fas",
        iconName: "ve-operators-nested-loop-join" as IconName,
        icon: [
            42.0,
            42.0,
            [],
            "",
            "M40 42H6c-1.1 0-2-.9-2-2V12.4l-2.3 2.3c-.4.4-1 .4-1.4 0s-.4-1 0-1.4l4-4c.4-.4 1-.4 1.4 0l4 4c.4.4.4 1 0 1.4-.4.4-1 .4-1.4 0L6 12.4V40h34V2H6v3c0 .6-.4 1-1 1s-1-.4-1-1V2c0-1.1.9-2 2-2h34c1.1 0 2 .9 2 2v38c0 1.1-.9 2-2 2zM14.7 17.3c-.4-.4-1-.4-1.4 0l-4 4c-.4.4-.4 1 0 1.4.4.4 1 .4 1.4 0l2.3-2.3V33c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V9c0-1.1-.9-2-2-2H15c-1.1 0-2 .9-2 2v4c0 .6.4 1 1 1s1-.4 1-1V9h18v24H15V20.4l2.3 2.3c.4.4 1 .4 1.4 0 .4-.4.4-1 0-1.4l-4-4z",
        ],
    },
    veoperatorsunionall: {
        prefix: "fas",
        iconName: "ve-operators-union-all" as IconName,
        icon: [
            42.0,
            42.0,
            [],
            "",
            "M37 6c0-.6-.4-1-1-1H6c-.6 0-1 .4-1 1s.4 1 1 1h30c.6 0 1-.4 1-1zm5-4c0-1.1-.9-2-2-2H2C.9 0 0 .9 0 2v8c0 1.1.9 2 2 2h38c1.1 0 2-.9 2-2V2zm-2 0v8H2V2h38zM22 17c0-.6-.4-1-1-1s-1 .4-1 1v3h-3c-.6 0-1 .4-1 1s.4 1 1 1h3v3c0 .6.4 1 1 1s1-.4 1-1v-3h3c.6 0 1-.4 1-1s-.4-1-1-1h-3v-3zm14 18c.6 0 1 .4 1 1s-.4 1-1 1H6c-.6 0-1-.4-1-1s.4-1 1-1h30zm6-3c0-1.1-.9-2-2-2H2c-1.1 0-2 .9-2 2v8c0 1.1.9 2 2 2h38c1.1 0 2-.9 2-2v-8zm-2 0v8H2v-8h38z",
        ],
    },
    veoperatorshashgroupby: {
        prefix: "fas",
        iconName: "ve-operators-hash-group-by" as IconName,
        icon: [26.0, 42.0, [], "", "M0 0h6v42H0V0zm0 3V0h26v3H0z"],
    },
    veoperatorsgathermerge: {
        prefix: "fas",
        iconName: "ve-operators-gather-merge" as IconName,
        icon: [
            40.0,
            40.0,
            [],
            "",
            "M39.7 1.7c.4-.4.4-1 0-1.4s-1-.4-1.4 0L33 5.6V4c0-.6-.4-1-1-1s-1 .4-1 1v4c0 .3.1.5.3.7.2.2.4.3.7.3h4c.6 0 1-.4 1-1s-.4-1-1-1h-1.6l5.3-5.3zm0 36.6c.4.4.4 1 0 1.4s-1 .4-1.4 0L33 34.4V36c0 .6-.4 1-1 1s-1-.4-1-1v-4c0-.3.1-.5.3-.7s.4-.3.7-.3h4c.6 0 1 .4 1 1s-.4 1-1 1h-1.6l5.3 5.3zM.3 39.7c-.4-.4-.4-1 0-1.4L5.6 33H4c-.6 0-1-.4-1-1s.4-1 1-1h4c.3 0 .5.1.7.3.2.2.3.4.3.7v4c0 .6-.4 1-1 1s-1-.4-1-1v-1.6l-5.3 5.3c-.4.4-1 .4-1.4 0zm0-38C-.1 1.3-.1.7.3.3c.4-.4 1-.4 1.4 0L7 5.6V4c0-.6.4-1 1-1s1 .4 1 1v4c0 .3-.1.5-.3.7-.2.2-.4.3-.7.3H4c-.6 0-1-.4-1-1s.4-1 1-1h1.6L.3 1.7zm31.8 18.2c0 6.6-5.4 12-12 12s-12-5.4-12-12 5.4-12 12-12 12 5.3 12 12zm-11.4-7.6c-.4-.4-1-.4-1.4 0l-4 4c-.4.4-.4 1 0 1.4.4.4 1 .4 1.4 0l2.3-2.3V27c0 .6.4 1 1 1s1-.4 1-1V15.4l2.3 2.3c.4.4 1 .4 1.4 0 .4-.4.4-1 0-1.4l-4-4z",
        ],
    },
    veoperatorsorderedcolumnstorescan: {
        prefix: "fas",
        iconName: "ve-operators-ordered-column-store-scan" as IconName,
        icon: [
            42.0,
            42.0,
            [],
            "",
            "M21.7 9.3c-.4-.4-1-.4-1.4 0l-4 4c-.4.4-.4 1 0 1.4.4.4 1 .4 1.4 0l2.3-2.3V36c0 .6.4 1 1 1s1-.4 1-1V12.4l2.3 2.3c.4.4 1 .4 1.4 0 .4-.4.4-1 0-1.4l-4-4zM0 2C0 .9.9 0 2 0h38c1.1 0 2 .9 2 2v38c0 1.1-.9 2-2 2H2c-1.1 0-2-.9-2-2V2zm2 4v34h8V6H2zm9.9 34H30V6H11.9v34zm20 0H40V6h-8.1v34z",
        ],
    },
    veoperatorsaggregate: {
        prefix: "fas",
        iconName: "ve-operators-aggregate" as IconName,
        icon: [
            34.0,
            43.0,
            [],
            "",
            "M29.343.5c-.014 0-.028 0-.042.002L25.665.81H1.305a.5.5 0 0 0-.449.28c-.142.287-.336.996 0 1.68.035.072.113.186.186.293.086.124.204.29.349.493.29.405.695.963 1.188 1.636.896 1.225 2.084 2.837 3.399 4.622l.399.542c2.856 3.877 6.216 8.442 8.499 11.63-.893 1.144-1.955 2.496-3.09 3.942a1732.047 1732.047 0 0 0-5.683 7.263 320.245 320.245 0 0 0-3.896 5.095 52.28 52.28 0 0 0-1.19 1.653 9.332 9.332 0 0 0-.338.528c-.04.07-.078.14-.107.204v.001a.728.728 0 0 0-.072.295v.62a.5.5 0 0 0 .506.5c6.891-.089 19.805-.025 23.803-.005h.007l1.162.005.04.005.162.026.207.036.03.005.3.052c.432.073.997.162 1.585.222.584.06 1.21.092 1.76.044.518-.045 1.101-.169 1.466-.54a.994.994 0 0 1 .048-.043c.109-.094.338-.292.475-.616.157-.371.23-.924.23-1.86 0-.877.295-2.844.602-4.64a152.136 152.136 0 0 1 .556-3.05l.038-.2.014-.069a.5.5 0 0 0-.218-.515l-.001-.001-.002-.001-.006-.004-.016-.01a3.098 3.098 0 0 0-.244-.133 3.22 3.22 0 0 0-.638-.236c-.51-.126-1.261-.151-1.856.453-.134.136-.254.343-.356.538-.11.211-.231.471-.358.756-.113.255-.229.521-.35.8-.16.374-.332.77-.52 1.188-.322.711-.665 1.415-1.015 1.994-.362.598-.691.99-.962 1.154-.237.145-.421.267-.58.37-.402.267-.634.42-1.111.54-.69.176-1.845.256-4.448.256H7.51l13.884-17.8a.5.5 0 0 0 .01-.602L9.952 4.459l.456-.021c2.362-.107 5.437-.247 8.305-.237 1.735.005 3.38.066 4.738.219 1.385.156 2.379.4 2.88.72 1.04.66 1.538 1.95 1.88 3.267.068.261.134.538.197.807.083.353.163.692.24.959.073.248.157.492.269.692.107.193.281.425.57.523.45.152.952.177 1.372.158.426-.02.81-.087 1.045-.147a.5.5 0 0 0 .374-.541c-.152-1.342-.38-3.4-.571-5.216-.193-1.838-.34-3.375-.34-3.713 0-.659-.47-1.025-.87-1.2A3.026 3.026 0 0 0 29.342.5zm3.93 30.444l-.273.419.273-.42z",
        ],
    },
    veoperatorsindexseek: {
        prefix: "fas",
        iconName: "ve-operators-index-seek" as IconName,
        icon: [
            42.0,
            42.0,
            [],
            "",
            "M2 0a2 2 0 0 0-2 2v38a2 2 0 0 0 2 2h18a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2zm0 20V5h18v15H2zm18 3v17H2V23h18zm21.697-4.283a1 1 0 1 0-1.394-1.434l-9.16 8.906-4.446-4.323a1 1 0 0 0-1.394 1.434l5.143 5a1 1 0 0 0 1.394 0l9.857-9.583z",
        ],
    },
    veoperatorstablescan: {
        prefix: "fas",
        iconName: "ve-operators-table-scan" as IconName,
        icon: [
            42.0,
            42.0,
            [],
            "",
            "M2 0a2 2 0 0 0-2 2v38a2 2 0 0 0 2 2h38a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2zm0 16V6.5h11V16H2zm13 0V6.5h12V16H15zm14 0V6.5h11V16H29zm0 2h11v10H29V18zm0 12h11v10H29V30zm-2 0v10H15V30h12zm-14 0v10H2V30h11zm0-2H2V18h11v10zm2 0V18h12v10H15z",
        ],
    },
    veoperatorsbloomfilter: {
        prefix: "fas",
        iconName: "ve-operators-bloom-filter" as IconName,
        icon: [
            40.0,
            42.0,
            [],
            "",
            "M2.237 0C.507 0-.407 2.045.747 3.334L16 20.382v16.15a2 2 0 0 0 .72 1.536l4 3.333c1.302 1.086 3.28.16 3.28-1.536V20.382L39.254 3.334C40.407 2.045 39.492 0 37.764 0H2.236zM20 2h17.763L22.255 19.333A1 1 0 0 0 22 20v19.865l-2-1.667V2z",
        ],
    },
    veoperatorsbroadcast: {
        prefix: "fas",
        iconName: "ve-operators-broadcast" as IconName,
        icon: [
            43.0,
            32.0,
            [],
            "",
            "M7.7.3c.4.4.4 1 0 1.4C4.2 5.3 2 10.2 2 15.7s2.2 10.5 5.8 14.1c.4.4.4 1 0 1.4-.4.4-1 .4-1.4 0-4-4-6.4-9.5-6.4-15.5S2.4 4.3 6.3.3c.4-.4 1-.4 1.4 0zm22 24c-.4.4-.4 1 0 1.4.4.4 1 .4 1.4 0 2.4-2.5 3.9-5.9 3.9-9.7 0-4-1.7-7.6-4.3-10.1-.4-.4-1-.4-1.4 0-.4.4-.4 1 0 1.4C31.6 9.5 33 12.6 33 16c0 3.2-1.3 6.2-3.3 8.3zm-17.4-18c.4.4.4 1 0 1.4C10.3 9.8 9 12.8 9 16c0 3.4 1.4 6.5 3.7 8.7.4.4.4 1 0 1.4-.4.4-1 .4-1.4 0C8.7 23.6 7 20 7 16c0-3.8 1.5-7.2 3.9-9.7.4-.4 1-.4 1.4 0zM28 16c0 3.9-3.1 7-7 7s-7-3.1-7-7 3.1-7 7-7 7 3.1 7 7zm6.4 13.8c-.4.4-.4 1 0 1.4.4.4 1 .4 1.4 0 3.9-4 6.3-9.4 6.3-15.4 0-6.1-2.5-11.6-6.4-15.5-.4-.4-1-.4-1.4 0-.4.4-.4 1 0 1.4 3.6 3.6 5.8 8.6 5.8 14.1s-2.2 10.4-5.7 14z",
        ],
    },
    veoperatorspartition: {
        prefix: "fas",
        iconName: "ve-operators-partition" as IconName,
        icon: [
            44.0,
            42.0,
            [],
            "",
            "M42.5 30c.6 0 1-.4 1-1s-.4-1-1-1h-1c-.6 0-1 .4-1 1s.4 1 1 1h1zm-5 0c.6 0 1-.4 1-1s-.4-1-1-1h-4c-.6 0-1 .4-1 1s.4 1 1 1h4zm-8 0c.6 0 1-.4 1-1s-.4-1-1-1h-4c-.6 0-1 .4-1 1s.4 1 1 1h4zm-8 0c.6 0 1-.4 1-1s-.4-1-1-1h-4c-.6 0-1 .4-1 1s.4 1 1 1h4zm-8 0c.6 0 1-.4 1-1s-.4-1-1-1h-4c-.6 0-1 .4-1 1s.4 1 1 1h4zm-8 0c.6 0 1-.4 1-1s-.4-1-1-1h-4c-.6 0-1 .4-1 1s.4 1 1 1h4zm37-16c.6 0 1-.4 1-1s-.4-1-1-1h-1c-.6 0-1 .4-1 1s.4 1 1 1h1zm-5 0c.6 0 1-.4 1-1s-.4-1-1-1h-4c-.6 0-1 .4-1 1s.4 1 1 1h4zm-8 0c.6 0 1-.4 1-1s-.4-1-1-1h-4c-.6 0-1 .4-1 1s.4 1 1 1h4zm-8 0c.6 0 1-.4 1-1s-.4-1-1-1h-4c-.6 0-1 .4-1 1s.4 1 1 1h4zm-8 0c.6 0 1-.4 1-1s-.4-1-1-1h-4c-.6 0-1 .4-1 1s.4 1 1 1h4zm-8 0c.6 0 1-.4 1-1s-.4-1-1-1h-4c-.6 0-1 .4-1 1s.4 1 1 1h4zM33 42c1.1 0 2-.9 2-2V2c0-1.1-.9-2-2-2H11C9.9 0 9 .9 9 2v38c0 1.1.9 2 2 2h22zM11 2h22v38H11V2z",
        ],
    },
    veoperatorstop: {
        prefix: "fas",
        iconName: "ve-operators-top" as IconName,
        icon: [
            42.0,
            42.0,
            [],
            "",
            "M37 2a2 2 0 0 0-2-2H7a2 2 0 0 0-2 2v12H1a1 1 0 1 0 0 2h4v24a2 2 0 0 0 2 2h28a2 2 0 0 0 2-2V16h4a1 1 0 1 0 0-2h-4V2zM7 16h28v24H7V16z",
        ],
    },
    veoperatorsgather: {
        prefix: "fas",
        iconName: "ve-operators-gather" as IconName,
        icon: [
            40.0,
            40.0,
            [],
            "",
            "M39.7 1.7c.4-.4.4-1 0-1.4s-1-.4-1.4 0L33 5.6V4c0-.6-.4-1-1-1s-1 .4-1 1v4c0 .3.1.5.3.7.2.2.4.3.7.3h4c.6 0 1-.4 1-1s-.4-1-1-1h-1.6l5.3-5.3zM32 20c0 6.6-5.4 12-12 12S8 26.6 8 20 13.4 8 20 8s12 5.4 12 12zm7.7 19.7c.4-.4.4-1 0-1.4L34.4 33H36c.6 0 1-.4 1-1s-.4-1-1-1h-4c-.3 0-.5.1-.7.3s-.3.4-.3.7v4c0 .6.4 1 1 1s1-.4 1-1v-1.6l5.3 5.3c.4.4 1 .4 1.4 0zM.3 38.3c-.4.4-.4 1 0 1.4.4.4 1 .4 1.4 0L7 34.4V36c0 .6.4 1 1 1s1-.4 1-1v-4c0-.3-.1-.5-.3-.7-.2-.2-.4-.3-.7-.3H4c-.6 0-1 .4-1 1s.4 1 1 1h1.6L.3 38.3zm0-38c-.4.4-.4 1 0 1.4L5.6 7H4c-.6 0-1 .4-1 1s.4 1 1 1h4c.3 0 .5-.1.7-.3.2-.2.3-.4.3-.7V4c0-.6-.4-1-1-1s-1 .4-1 1v1.6L1.7.3C1.3-.1.7-.1.3.3z",
        ],
    },
    veoperatorsdelete: {
        prefix: "fas",
        iconName: "ve-operators-delete" as IconName,
        icon: [
            40.0,
            42.0,
            [],
            "",
            "M2 0a2 2 0 0 0-2 2v38a2 2 0 0 0 2 2h18a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2zm0 20V5h18v15H2zm18 3v17H2V23h18zm7.707-8.707a1 1 0 0 0-1.414 1.414L31.586 21l-5.293 5.293a1 1 0 0 0 1.414 1.414L33 22.414l5.293 5.293a1 1 0 0 0 1.414-1.414L34.414 21l5.293-5.293a1 1 0 0 0-1.414-1.414L33 19.586l-5.293-5.293z",
        ],
    },
    veoperatorsinsertinto: {
        prefix: "fas",
        iconName: "ve-operators-insert-into" as IconName,
        icon: [
            42.0,
            42.0,
            [],
            "",
            "M2 0a2 2 0 0 0-2 2v38a2 2 0 0 0 2 2h18a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2zm0 20V5h18v15H2zm18 3v17H2V23h18zm21-13a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1H29.414l4.293 4.293a1 1 0 0 1-1.414 1.414l-6-6a1 1 0 0 1 0-1.414l6-6a1 1 0 0 1 1.414 1.414L29.414 20H40v-9a1 1 0 0 1 1-1z",
        ],
    },
    veoperatorsrepartition: {
        prefix: "fas",
        iconName: "ve-operators-repartition" as IconName,
        icon: [
            42.0,
            42.0,
            [],
            "",
            "M12.606 11.192a7 7 0 1 0-1.414 1.414L19.586 21l-8.394 8.394a7 7 0 1 0 1.414 1.414L21 22.414l8.394 8.394a7 7 0 1 0 1.414-1.414L22.414 21l8.394-8.394a7 7 0 1 0-1.414-1.414L21 19.586l-8.394-8.394zM12 35a5 5 0 1 1-10 0 5 5 0 0 1 10 0zm28 0a5 5 0 1 1-10 0 5 5 0 0 1 10 0z",
        ],
    },
    veoperatorsfilter: {
        prefix: "fas",
        iconName: "ve-operators-filter" as IconName,
        icon: [
            40.0,
            42.0,
            [],
            "",
            "M17 20h1a1 1 0 0 0-.255-.667L17 20zm6 0l-.745-.667A1 1 0 0 0 22 20h1zm-1.64 20.633l-.64.768.64-.768zm-4-3.333l.64-.768-.64.768zM38.509 2.667l.745.667-.745-.667zM.746 3.334l15.509 17.333 1.49-1.334L2.237 2 .747 3.334zM16 20v16.532h2V20h-2zm.72 18.068l4 3.333L22 39.865l-4-3.333-1.28 1.536zM24 39.865V20h-2v19.865h2zm-.255-19.198L39.254 3.334 37.764 2l-15.51 17.333 1.491 1.334zM37.763 0H2.237v2h35.526V0zM20.72 41.401c1.302 1.086 3.28.16 3.28-1.536h-2l-1.28 1.536zM16 36.531a2 2 0 0 0 .72 1.537L18 36.532h-2zM39.254 3.335C40.407 2.045 39.492 0 37.764 0v2l1.49 1.334zM2.237 2V0C.507 0-.407 2.045.747 3.334L2.236 2z",
        ],
    },
    veoperatorsproject: {
        prefix: "fas",
        iconName: "ve-operators-project" as IconName,
        icon: [
            40.0,
            42.0,
            [],
            "",
            "M4.9 6c0-2.2-3.4-3-4.9-3.1V.5c7.2.5 31.5.5 39.6 0 .3.6.3 2 0 2.4-3.4.3-4.3 1.4-4.3 3.1v31.9c0 1.5 3.4 1.5 4.3 2.2.9.6 0 1.9 0 1.9s-13.8.3-14.7 0c-.9-.3-.6-1.5 0-1.9 1.1-.6 3.7-.6 4.3-2.2.5-1.2.2-23 0-33.8H10.8v33.8c0 1.2 2.7 1.2 4.3 2.2.6.6 0 1.9 0 1.9S1 42.3.4 42c-.7-.4-.4-1.7.2-2s4.2-1.7 4.3-2.2V6z",
        ],
    },
    veoperatorstopsort: {
        prefix: "fas",
        iconName: "ve-operators-top-sort" as IconName,
        icon: [
            42.0,
            42.0,
            [],
            "",
            "M36 0a1 1 0 0 1 1 1v13h4a1 1 0 1 1 0 2h-4v25a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V16H1a1 1 0 1 1 0-2h4V1a1 1 0 0 1 1-1h30zM7 16v24h28V16H22V7.414l2.293 2.293a1 1 0 0 0 1.414-1.414l-4-4a1 1 0 0 0-1.414 0l-4 4a1 1 0 0 0 1.414 1.414L20 7.414V16H7zm13 0v19a1 1 0 1 0 2 0V16h-2z",
        ],
    },
    veoperatorswindow: {
        prefix: "fas",
        iconName: "ve-operators-window" as IconName,
        icon: [
            42.0,
            42.0,
            [],
            "",
            "M0 2a2 2 0 0 1 2-2h18a2 2 0 0 1 2 2v14h18a2 2 0 0 1 2 2v7.5a2 2 0 0 1-2 2H22V40a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2zm22 23.5h18V18H22v7.5zM20 16V7H2v33h18V28H9a2 2 0 0 1-2-2v-8a2 2 0 0 1 2-2h11z",
        ],
    },
    veoperatorsindexrangescan: {
        prefix: "fas",
        iconName: "ve-operators-index-range-scan" as IconName,
        icon: [
            42.0,
            42.0,
            [],
            "",
            "M0 2a2 2 0 0 1 2-2h38a2 2 0 0 1 2 2v38a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2zm2 25v13h38V27H2zm0-15h38V6H2v6z",
        ],
    },
    veoperatorscolumnstorescan: {
        prefix: "fas",
        iconName: "ve-operators-columnstore-scan" as IconName,
        icon: [
            42.0,
            42.0,
            [],
            "",
            "M0 2a2 2 0 0 1 2-2h38a2 2 0 0 1 2 2v38a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2zm2 4v34h11V6H2zm12.912 34h12.176V6H14.912v34zM29 40h11V6H29v34z",
        ],
    },
    veoperatorsshufflegroupby: {
        prefix: "fas",
        iconName: "ve-operators-shuffle-group-by" as IconName,
        icon: [
            42.0,
            42.0,
            [],
            "",
            "M21 42c11.598 0 21-9.402 21-21S32.598 0 21 0 0 9.402 0 21s9.402 21 21 21zM14 8h17v2H18v25.071h-4V8z",
        ],
    },
    veoperatorsupdate: {
        prefix: "fas",
        iconName: "ve-operators-update" as IconName,
        icon: [
            42.0,
            42.0,
            [],
            "",
            "M32.313 1a2 2 0 0 1 2.828 0L41 6.859a2 2 0 0 1 0 2.828L8.687 42H0v-8.687L32.313 1zM2 34.142V40h5.859l23.863-23.864-5.858-5.858L2 34.14zM27.278 8.864l5.858 5.858 2.303-2.303-5.858-5.858-2.303 2.303z",
        ],
    },
    veoperatorsdistinct: {
        prefix: "fas",
        iconName: "ve-operators-distinct" as IconName,
        icon: [
            42.0,
            42.0,
            [],
            "",
            "M0 2a2 2 0 0 1 2-2h38a2 2 0 0 1 2 2v38a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2zm2 4v34h38V6H2zm6.707 10.293a1 1 0 0 0-1.414 1.414L11.586 22l-4.293 4.293a1 1 0 1 0 1.414 1.414L13 23.414l4.293 4.293a1 1 0 0 0 1.414-1.414L14.414 22l4.293-4.293a1 1 0 0 0-1.414-1.414L13 20.586l-4.293-4.293zm29.21 1.414a1 1 0 1 0-1.414-1.414l-9.293 9.293-3.503-3.504a1 1 0 1 0-1.414 1.415l4.21 4.21a1 1 0 0 0 1.415 0l10-10z",
        ],
    },
    veoperatorschooseplan: {
        prefix: "fas",
        iconName: "ve-operators-choose-plan" as IconName,
        icon: [
            43.0,
            42.0,
            [],
            "",
            "M19.6.6l-19 19c-.8.8-.8 2 0 2.8l19 19c.8.8 2 .8 2.8 0l19-19c.8-.8.8-2 0-2.8l-19-19c-.8-.8-2-.8-2.8 0zM13.9 26h-2.1v-3.9l-3.7-6.3h1.8c.2 0 .3 0 .4.1l.3.3 1.7 3.2.3.6c.1.2.2.4.2.6.1-.2.1-.4.2-.6l.3-.6 1.7-3.2c.1-.1.1-.2.3-.3s.3-.1.4-.1h1.9l-3.7 6.3V26zm4.2.5c-.2.1-.4.2-.6.2h-.8l4-10.5c.1-.2.2-.4.4-.5.2-.1.4-.2.6-.2h.8l-4 10.4c0 .3-.2.5-.4.6zm14.6-.5h-1.1c-.2 0-.3 0-.4-.1-.1-.1-.2-.1-.3-.3l-5.1-6.4V26H24V15.8h1.5c.1 0 .1.1.1.1l.2.2 5.1 6.5v-.5-6.3h1.9V26z",
        ],
    },
    veoperatorshashjoin: {
        prefix: "fas",
        iconName: "ve-operators-hash-join" as IconName,
        icon: [
            42.0,
            42.0,
            [],
            "",
            "M20 0c1.1 0 2 .9 2 2v38c0 1.1-.9 2-2 2H2c-1.1 0-2-.9-2-2V2C0 .9.9 0 2 0h18zm0 6H2v34h18V6zm5.3 4.7l3 3c.4.4 1 .4 1.4 0 .4-.4.4-1 0-1.4L28.4 11H41c.6 0 1-.4 1-1s-.4-1-1-1H28.4l1.3-1.3c.4-.4.4-1 0-1.4-.4-.4-1-.4-1.4 0l-3 3c-.4.4-.4 1 0 1.4zm4.4 12.6L28.4 22H41c.6 0 1-.4 1-1s-.4-1-1-1H28.4l1.3-1.3c.4-.4.4-1 0-1.4-.4-.4-1-.4-1.4 0l-3 3c-.4.4-.4 1 0 1.4l3 3c.4.4 1 .4 1.4 0 .4-.4.4-1 0-1.4zM28.4 31H41c.6 0 1 .4 1 1s-.4 1-1 1H28.4l1.3 1.3c.4.4.4 1 0 1.4-.4.4-1 .4-1.4 0l-3-3c-.4-.4-.4-1 0-1.4l3-3c.4-.4 1-.4 1.4 0 .4.4.4 1 0 1.4L28.4 31zM17 13c0-.6-.4-1-1-1H6c-.6 0-1 .4-1 1s.4 1 1 1h10c.6 0 1-.4 1-1zm0 20c0-.6-.4-1-1-1H6c-.6 0-1 .4-1 1s.4 1 1 1h10c.6 0 1-.4 1-1zm-1-11c.6 0 1 .4 1 1s-.4 1-1 1H6c-.6 0-1-.4-1-1s.4-1 1-1h10z",
        ],
    },
    veoperatorssort: {
        prefix: "fas",
        iconName: "ve-operators-sort" as IconName,
        icon: [
            40.0,
            42.0,
            [],
            "",
            "M35.7.3c-.4-.4-1-.4-1.4 0l-4 4c-.4.4-.4 1 0 1.4.4.4 1 .4 1.4 0L34 3.4V41c0 .6.4 1 1 1s1-.4 1-1V3.4l2.3 2.3c.4.4 1 .4 1.4 0 .4-.4.4-1 0-1.4l-4-4zM28 5v3c0 1.1-.9 2-2 2H2c-1.1 0-2-.9-2-2V5c0-1.1.9-2 2-2h24c1.1 0 2 .9 2 2zm0 13v-3c0-1.1-.9-2-2-2H8c-1.1 0-2 .9-2 2v3c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2zm0 7v3c0 1.1-.9 2-2 2H14c-1.1 0-2-.9-2-2v-3c0-1.1.9-2 2-2h12c1.1 0 2 .9 2 2zm0 13v-3c0-1.1-.9-2-2-2h-6c-1.1 0-2 .9-2 2v3c0 1.1.9 2 2 2h6c1.1 0 2-.9 2-2z",
        ],
    },
    veoperatorshashtablebuild: {
        prefix: "fas",
        iconName: "ve-operators-hash-table-build" as IconName,
        icon: [
            42.0,
            42.0,
            [],
            "",
            "M13.7 13.7l3-3c.4-.4.4-1 0-1.4l-3-3c-.4-.4-1-.4-1.4 0-.4.4-.4 1 0 1.4L13.6 9H1c-.6 0-1 .4-1 1s.4 1 1 1h12.6l-1.3 1.3c-.4.4-.4 1 0 1.4.4.4 1 .4 1.4 0zm-.1 8.3l-1.3 1.3c-.4.4-.4 1 0 1.4.4.4 1 .4 1.4 0l3-3c.4-.4.4-1 0-1.4l-3-3c-.4-.4-1-.4-1.4 0-.4.4-.4 1 0 1.4l1.3 1.3H1c-.6 0-1 .4-1 1s.4 1 1 1h12.6zm0 9H1c-.6 0-1 .4-1 1s.4 1 1 1h12.6l-1.3 1.3c-.4.4-.4 1 0 1.4.4.4 1 .4 1.4 0l3-3c.4-.4.4-1 0-1.4l-3-3c-.4-.4-1-.4-1.4 0-.4.4-.4 1 0 1.4l1.3 1.3zM22 0c-1.1 0-2 .9-2 2v38c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V2c0-1.1-.9-2-2-2H22zm0 6h18v34H22V6zm7 18c.6 0 1-.4 1-1s-.4-1-1-1v2zm-4-1v-1h-1v1h1zm-1 4c0 .6.4 1 1 1s1-.4 1-1h-2zm9-9c-.6 0-1 .4-1 1s.4 1 1 1v-2zm4 1v1h1v-1h-1zm1-4c0-.6-.4-1-1-1s-1 .4-1 1h2zm-3 7c0 2.2-1.8 4-4 4v2c3.3 0 6-2.7 6-6h-2zm-4 4c-1.9 0-3.4-1.3-3.9-3l-1.9.5c.7 2.6 3 4.5 5.8 4.5v-2zm-2-4h-4v2h4v-2zm-5 1v4h2v-4h-2zm3-3c0-2.2 1.8-4 4-4v-2c-3.3 0-6 2.7-6 6h2zm4-4c1.9 0 3.4 1.3 3.9 3l1.9-.5c-.7-2.6-3-4.5-5.8-4.5v2zm2 4h4v-2h-4v2zm5-1v-4h-2v4h2z",
        ],
    },
    veoperatorsstreaminggroupby: {
        prefix: "fas",
        iconName: "ve-operators-streaming-group-by" as IconName,
        icon: [
            39.0,
            42.0,
            [],
            "",
            "M0 0v42h6V3h20V0H0zm14.3 10.7c-.4-.4-.4-1 0-1.4l4-4c.4-.4 1-.4 1.4 0 .4.4.4 1 0 1.4L17.4 9H38c.6 0 1 .4 1 1s-.4 1-1 1H17.4l2.3 2.3c.4.4.4 1 0 1.4-.4.4-1 .4-1.4 0l-4-4zM17.4 24l2.3 2.3c.4.4.4 1 0 1.4-.4.4-1 .4-1.4 0l-4-4c-.4-.4-.4-1 0-1.4l4-4c.4-.4 1-.4 1.4 0 .4.4.4 1 0 1.4L17.4 22H38c.6 0 1 .4 1 1s-.4 1-1 1H17.4zm-3.1 12.7c-.4-.4-.4-1 0-1.4l4-4c.4-.4 1-.4 1.4 0 .4.4.4 1 0 1.4L17.4 35H38c.6 0 1 .4 1 1s-.4 1-1 1H17.4l2.3 2.3c.4.4.4 1 0 1.4-.4.4-1 .4-1.4 0l-4-4z",
        ],
    },
    veoperatorsmergejoin: {
        prefix: "fas",
        iconName: "ve-operators-merge-join" as IconName,
        icon: [
            42.0,
            42.0,
            [],
            "",
            "M21.707.293a1 1 0 0 0-1.414 0l-4 4a1 1 0 0 0 1.414 1.414L20 3.414v17.172l-8 8V2a2 2 0 0 0-2-2H2a2 2 0 0 0-2 2v38a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2v-8.586l9-9 9 9V40a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2h-8a2 2 0 0 0-2 2v26.586l-8-8V3.414l2.293 2.293a1 1 0 1 0 1.414-1.414l-4-4zM2 2h8v38H2V2zm30 0h8v38h-8V2zM6 4a1 1 0 0 1 1 1v32a1 1 0 1 1-2 0V5a1 1 0 0 1 1-1zm31 1a1 1 0 1 0-2 0v32a1 1 0 1 0 2 0V5z",
        ],
    },
    dashboard: {
        prefix: "fas",
        iconName: "dashboard" as IconName,
        icon: [
            16.0,
            16.0,
            [],
            "",
            "M0.5,0C0.2,0,0,0.2,0,0.5v4C0,4.8,0.2,5,0.5,5h15C15.8,5,16,4.8,16,4.5v-4C16,0.2,15.8,0,15.5,0H0.5z M6.5,7  C6.2,7,6,7.2,6,7.5v6C6,13.8,6.2,14,6.5,14h3c0.3,0,0.5-0.2,0.5-0.5v-6C10,7.2,9.8,7,9.5,7H6.5z M0,7.5C0,7.2,0.2,7,0.5,7h3  C3.8,7,4,7.2,4,7.5v6C4,13.8,3.8,14,3.5,14h-3C0.2,14,0,13.8,0,13.5V7.5z M12.5,7C12.2,7,12,7.2,12,7.5v6c0,0.3,0.2,0.5,0.5,0.5h3  c0.3,0,0.5-0.2,0.5-0.5v-6C16,7.2,15.8,7,15.5,7H12.5z",
        ],
    },
    host: {
        prefix: "fas",
        iconName: "host" as IconName,
        icon: [
            16.0,
            16.0,
            [],
            "",
            "M13,1.5C13,0.6,10.8,0,8,0C5.2,0,3,0.7,3,1.5v0.7C3,3,5.2,3.6,8,3.6c2.8,0,5-0.7,5-1.5V1.5z M13,6.6  c-1.1,0.7-3.1,1-5,1s-3.9-0.3-5-1v2C3,9.3,5,9.9,7.5,10v2.1c-0.7,0.2-1.3,0.7-1.4,1.4H2.9c-0.2-0.6-0.8-1-1.4-1  C0.7,12.5,0,13.2,0,14s0.7,1.5,1.5,1.5c0.7,0,1.2-0.4,1.4-1h3.1C6.3,15.4,7.1,16,8,16s1.7-0.6,1.9-1.5h3.1c0.2,0.6,0.8,1,1.4,1  c0.8,0,1.5-0.7,1.5-1.5s-0.7-1.5-1.5-1.5c-0.7,0-1.2,0.4-1.4,1H9.9c-0.2-0.7-0.7-1.3-1.4-1.4V10C11,9.9,13,9.3,13,8.5V6.6z M13,3.4  c-1.1,0.7-3.1,1-5,1S4.1,4,3,3.4v2c0,0.8,2.2,1.5,5,1.5c2.8,0,5-0.7,5-1.5V3.4z",
        ],
    },
};

export default ICON_PACK;
